import React from "react";
import { withTranslation } from "react-i18next";
import { Form, Input, Typography } from "antd";
import { CustomInput } from "../customComponent/CustomInput";

const { TextArea } = Input;
const { Text } = Typography;

const TaskFormItemComponent = ({
  t,
  style,
  label,
  textArea = false,
  required = true,
  editable = true,
  showLabel = false,
  strong = false,
  id
}) => (
  <Form.Item
    name="text"
    colon={false}
    label={showLabel ? <Text strong={strong}>{label ? label : t("form.task.label")}</Text> : null}
    rules={[{ required, message: t("form.task.error_required") }]}
    style={style}
  >
    {textArea ? (
      <TextArea rows={4} disabled={!editable} placeholder={t("form.task.placeholder")} />
    ) : (
      <CustomInput id={id} disabled={!editable} placeholder={t("form.task.placeholder")} />
    )}
  </Form.Item>
);

const TaskFormItem = withTranslation()(TaskFormItemComponent);

export { TaskFormItem };
